import {
    //cart
    VIEW_CART,
    ADD_TO_CART,
    REMOVE_FROM_CART,
  } from './mutation-types'
  
//cart
export const cartMutations = {
    [VIEW_CART]: (state) => {
      return state.cart
    },
    [ADD_TO_CART]: (state, payload) => {state.cart; console.log(7879866856+'---'+state.cart);
      state.cart.push(payload); console.log(78+'---'+payload._id);
      state.cart = state.cart;console.log(state.cart);
    },
    [REMOVE_FROM_CART]: (state, payload) => {console.log(9123);console.log(state.cart);
      const index = state.cart.findIndex(p => p._id === payload)
      state.cart.splice(index, 1);console.log(2323);
      console.log(state.cart);
    }
}
  
  


// WEBPACK FOOTER //
// ./src/store/mutations.js